<div class="footer-container" [class.collapsed]="isCollapsed()">
  <button class="toggle-btn" (click)="toggleFooter()" [attr.aria-expanded]="!isCollapsed()">
    {{ isCollapsed() ? 'Expand Footer' : 'Collapse Footer' }}
  </button>
  <div class="footer-content" [class.collapsed]="isCollapsed()">
    <tds-footer></tds-footer>
  </div>
</div>